import * as TombstoneOperations from './actions/tombstoneOperations';
// Export TombstoneOperations API
export default TombstoneOperations;
// Export public types
export { RemoveFromTombstoneConditionType, } from './store/schema/RemoveFromTombstoneCondition';
//# sourceMappingURL=index.js.map